/* Imports
-------------------------------------------------------------- */

// @codekit-prepend "js/jquery.lettering.js";
// @codekit-prepend "js/jquery.nice-select.min.js";
// @codekit-prepend "js/slick.js";

/* Sliders
-------------------------------------------------------------- */

jQuery(".testimonials__slider").slick({
	useTransform: true,
	cssEase: "ease-in-out",
	speed: 1000,
	dots: true,
	speed: 1000,
	slidesToShow: 2,
	slidesToScroll: 1,
	arrows: false,
	autoplay: true,
	autoplaySpeed: 5000,
	adaptiveHeight: true,
	responsive: [
		{
			breakpoint: 1100,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
	],
});

jQuery(".case-results__slider")
	.slick({
		useTransform: true,
		cssEase: "ease-in-out",
		speed: 1000,
		dots: false,
		speed: 1000,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		prevArrow: ".case-results__arrow--prev",
		nextArrow: ".case-results__arrow--next",
		responsive: [
			{
				breakpoint: 1100,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	})
	.on("setPosition", function (event, slick) {
		slick.$slides.css("height", slick.$slideTrack.height() + "px");
	});

jQuery(".trust-logos__slider").slick({
	useTransform: true,
	cssEase: "ease-in-out",
	speed: 1000,
	dots: true,
	speed: 1000,
	slidesToShow: 4,
	slidesToScroll: 1,
	arrows: false,
	autoplay: true,
	autoplaySpeed: 3000,
	adaptiveHeight: true,
	responsive: [
		{
			breakpoint: 1100,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
			},
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
	],
});

jQuery(".profile-slider__slick-slider").slick({
	useTransform: true,
	cssEase: "ease-in-out",
	speed: 1000,
	slidesToShow: 3,
	slidesToScroll: 1,
	arrows: false,
	arrows: true,
	prevArrow: ".profile-slider__arrow--prev",
	nextArrow: ".profile-slider__arrow--next",
	responsive: [
		{
			breakpoint: 1100,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
			},
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
	],
});
jQuery(".hp-hero__logos-slider").slick({
	useTransform: true,
	cssEase: "ease-in-out",
	speed: 1000,
	slidesToShow: 3,
	slidesToScroll: 1,
	arrows: false,
	autoplay: true,
	autoplaySpeed: 3000,
	adaptiveHeight: true,
	responsive: [
		{
			breakpoint: 769,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
			},
		},
		{
			breakpoint: 500,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
			},
		},
	],
});

/* Smooth Scroll
-------------------------------------------------------------- */

jQuery(".smooth-scroll").click(function (event) {
	jQuery("html,body").animate(
		{ scrollTop: jQuery(this.hash).offset().top },
		1500
	);
});

/* Custom JS
-------------------------------------------------------------- */

jQuery(document).ready(function () {
	// Select last word with lettering.js
	jQuery(".last-word").lettering("words");

	// NiceSelect.js
	jQuery("select").niceSelect();

	// Mobile menu button
	jQuery(".mobile-nav-btn").click(function () {
		jQuery(".top-nav__nav").toggle();
	});

	// Show sub-menus
	jQuery(".top-nav .menu-item-has-children a").click(function () {
		jQuery(this).siblings(".sub-menu").toggle();
	});

	// Hero line heights
	let hpHeroHeight = jQuery(".hp-hero").outerHeight();
	let internalHeroHeight = jQuery(".internal-hero").outerHeight();
	let navHeight = jQuery(".top-nav__inner").outerHeight();

	let internalHeroAccentLineHeight = internalHeroHeight - navHeight - 37;
	let heroAccentLineHeight = hpHeroHeight - navHeight - 27;

	jQuery(".internal-hero__line-accent").css(
		"height",
		internalHeroAccentLineHeight
	);

	jQuery(".hp-hero__line-accent").css("height", heroAccentLineHeight);

	// Wrap iframes in content with wrapper to allow for full width
	jQuery(".general-content__main iframe").wrap(
		"<div class='iframe-container'></div>"
	);
	jQuery(".scheme").click(function () {
		jQuery(".scheme").removeClass("active");
		jQuery(this).addClass("active");

		var currentColorScheme = jQuery(this).attr("data-scheme");

		jQuery("body").removeAttr("data-color-scheme");
		jQuery("body").attr("data-color-scheme", currentColorScheme);
	});
});
